import { Help } from 'components/inputs'
import DocumentRequests from 'documents/components/DocumentRequests'
import { QuestionEditorComponentProps } from 'jobs/questions/props'
import { last } from 'lodash'
import { observer } from 'mobx-react'
import * as React from 'react'
import DocumentsQuestionViewModel from '../../DocumentsQuestionViewModel'

interface Props
  extends QuestionEditorComponentProps<DocumentsQuestionViewModel> {}

export default observer(function DocumentsEditorInput({
  vm,
  onFocus,
  focus$,
  disabled,
}: Props) {
  return (
    <div>
      <DocumentRequests
        onFocus={onFocus}
        focus$={focus$}
        vm={vm.documentRequests}
        disabled={disabled}
        readOnly={vm.settings.readOnly}
      />

      <Help
        error={vm.settings?.showErrorMessages ? last(vm.validationErrors) : ''}
      />
    </div>
  )
})
